import { useMemo } from "react";

import { MenuItem } from "custom-types/MenuItem";

const useStaffPicks = (menuItems: MenuItem[]) => {
  const staffPicks = useMemo(
    () => menuItems.filter((menuItem) => menuItem.isStaffPick),
    [menuItems]
  );

  const nonStaffPicks = useMemo(
    () => menuItems.filter((menuItem) => !menuItem.isStaffPick),
    [menuItems]
  );
  return { nonStaffPicks, staffPicks };
};

export default useStaffPicks;
